import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-labels-popover',
    templateUrl: './labels-popover.component.html',
    styleUrls: ['./labels-popover.component.scss'],
    standalone: false
})
export class LabelsPopoverComponent {
    Object = Object;
	@Input() labels: { [key: string]: string } = {};
	@Input() title: string;
	@Input() labelTextMapping: { [k: string]: string };

	@Input() NO_VALUE_LABEL: string;

	isOpen = false;
}
